import GridViewIcon from '@mui/icons-material/GridView';
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined';
import { IconButton } from '@mui/material';

export enum SearchResultMode {
  GRID = 'GRID',
  LIST = 'LIST'
}

interface SearchResultModeToggleProps {
  mode: SearchResultMode;
  onModeChange: (mode: SearchResultMode) => void;
}

export const SearchResultModeToggle: React.FC<
  SearchResultModeToggleProps
> = props => {
  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <IconButton
        size="small"
        onClick={() => props.onModeChange(SearchResultMode.GRID)}
        className={props.mode === SearchResultMode.GRID ? 'active' : undefined}
      >
        <GridViewIcon />
      </IconButton>
      <IconButton
        size="small"
        onClick={() => props.onModeChange(SearchResultMode.LIST)}
        className={props.mode === SearchResultMode.LIST ? 'active' : undefined}
      >
        <ViewListOutlinedIcon />
      </IconButton>
    </div>
  );
};
